import React from 'react';
import { ArrowRightIcon, HandshakeIcon, MailIcon, UsersIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { CompanyPageLayout } from '../components/CompanyPageLayout';
export function PartnerWithUs() {
  return <CompanyPageLayout eyebrow="Partner with us" title="Build more considered Nepal journeys together." intro="We welcome conversations with travel advisors, international operators, and local businesses who share our commitment to thoughtful, locally rooted travel." data-id="element-909">
      <section className="px-5 py-20 sm:px-8 sm:py-28 lg:px-12" data-id="element-910">
        <div className="mx-auto grid max-w-[1180px] gap-12 lg:grid-cols-[0.72fr_1.28fr] lg:gap-24" data-id="element-911">
          <div data-id="element-912">
            <HandshakeIcon className="h-9 w-9 text-[#4f8057]" aria-hidden="true" data-id="element-913" />
            <h2 className="mt-6 font-serif text-4xl leading-tight" data-id="element-914">
              A partnership with local depth.
            </h2>
          </div>
          <div data-id="element-915">
            <p className="text-lg leading-8 text-[#52635a]" data-id="element-916">
              Whether you are looking for a trusted on-ground team, thoughtful
              private itineraries, or small-group operational support, we bring
              clear communication and experience across Nepal&apos;s most
              compelling regions.
            </p>
            <div className="mt-10 grid gap-6 sm:grid-cols-2" data-id="element-917">
              <article className="border-t border-[#9eaa9e] pt-5" data-id="element-918">
                <UsersIcon className="h-6 w-6 text-[#4f8057]" aria-hidden="true" data-id="element-919" />
                <h3 className="mt-5 font-serif text-2xl" data-id="element-920">
                  For travel advisors
                </h3>
                <p className="mt-3 leading-7 text-[#52635a]" data-id="element-921">
                  Tailored proposals, responsive local advice, and trip support
                  your clients can feel.
                </p>
              </article>
              <article className="border-t border-[#9eaa9e] pt-5" data-id="element-922">
                <MailIcon className="h-6 w-6 text-[#4f8057]" aria-hidden="true" data-id="element-923" />
                <h3 className="mt-5 font-serif text-2xl" data-id="element-924">For local partners</h3>
                <p className="mt-3 leading-7 text-[#52635a]" data-id="element-925">
                  Long-term relationships with businesses that make our journeys
                  more generous and grounded.
                </p>
              </article>
            </div>
            <Link to="/contact#plan-trip" className="mt-10 inline-flex items-center gap-2 bg-[#17362e] px-5 py-3 text-[10px] font-bold uppercase tracking-[0.16em] text-white transition-colors hover:bg-[#315c3b]" data-id="element-926">
              Start a partnership conversation
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-927" />
            </Link>
          </div>
        </div>
      </section>
      <section className="bg-[#e7e7db] px-5 py-16 sm:px-8 lg:px-12" data-id="element-928">
        <div className="mx-auto max-w-[1180px]" data-id="element-929">
          <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#4f8057]" data-id="element-930">
            How we begin
          </p>
          <ol className="mt-7 grid gap-6 md:grid-cols-3" data-id="element-931">
            {[['01', 'Tell us your vision', 'Share the type of travellers, journeys, or collaboration you have in mind.'], ['02', 'Shape the practicals', 'We will respond with local insight, possibilities, and transparent next steps.'], ['03', 'Build a lasting rhythm', 'Together, we create a clear way of working that serves guests and partners alike.']].map(([number, title, text]) => <li key={number} className="border-t border-[#9eaa9e] pt-5" data-id="element-932">
                <p className="text-[10px] font-bold tracking-[0.18em] text-[#4f8057]" data-id="element-933">
                  {number}
                </p>
                <h3 className="mt-4 font-serif text-2xl" data-id="element-934">{title}</h3>
                <p className="mt-3 leading-7 text-[#52635a]" data-id="element-935">{text}</p>
              </li>)}
          </ol>
        </div>
      </section>
    </CompanyPageLayout>;
}